<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useDebugStore } from '@/stores/settings/debug'

const { debugPresentation } = storeToRefs(useDebugStore())
</script>

<template>
  <div class="absolute min-h-full min-w-full" :class="{'debug-presentation': debugPresentation}">
    <slot></slot>
  </div>
</template>
